import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=6151c08d"
import script from "./AgeVerification.vue?vue&type=script&lang=ts"
export * from "./AgeVerification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports